export default {
  inject: ['tabContext'],
  computed: {
    context() {
      return this.tabContext()
    },
    selectedTab() {
      return this.context.selectedTab
    }
  }
}
